import { createGlobalStyle } from "styled-components";
import colors from "./colors";

const GlobalStyle = createGlobalStyle`
  html, body {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0px;
    padding: 0px;
    height: 100%;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  #notistack-snackbar {
    white-space: pre-wrap;
    max-width: 450px;
  }

  #notistack-snackbar + div {
    button {
      background-color: #00000060;
      color: white;
      font-weight: bold;
    }
  }

  #root {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
    background: ${colors.layoutColor};
  }
`;

export default GlobalStyle;
